import logo from '@/assets/logo.svg'

// 这里统一放首页三套页面的图片 URL 占位
// 你后续只要把这些字段替换成真实 URL 即可
export const homeImages = {
  logoUrl: logo,
  avatarUrl: '',
  mascotUrl: '',
  flameUrl: '',
  questionBannerBgUrl: ''
}

